import { cn } from "@bem-react/classname";
import { getProbMean, getTestMean, ITest, ITests, IUser, IUserResults, selectTeacherJournal} from "modules/TeacherJournal";
import { FC } from "react";
import "../Journal.scss"
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";


const Footer: FC<{test: ITest, results: IUserResults, users: IUser[]}> = ({test, results, users}) => {
    const jcn = cn('Journal')
    const state = useSelector(selectTeacherJournal)
    const mean = getTestMean(state, test, results, users)
    return <div className={jcn('Footer')}>
        {test.isOpen?<>
            <div className={jcn('Probline')}>
                {test.problems.map((item, index) => {
                    const mean = getProbMean(test, results, index)
                    let add = ''
                    let title = ""
                    if (mean !== null && mean < 0.75) {
                        add = ' Journal-red'
                        title = 'меньше 75%'
                    } else if (mean !== null && mean < 0.85) {
                        add = ' Journal-yellow'
                        title = 'от 75% до 85%'
                    } else if (mean !== null){
                        add = ' Journal-green'
                        title = 'больше 85%'
                    }
                    return <span className={jcn('Problineitem') + add} title={item.id.toString() + '\n' + title} key={index}>{mean?.toLocaleString()}</span>
                })}
            </div>
        </>:<>
        {mean?mean.toLocaleString():''}
        </>}
        
    </div>
}
export const FooterRow: FC<{ tests: ITests, results: IUserResults, users: IUser[]}> = ({tests, results, users}) => {
    const jcn = cn('Journal')
    return <>
    <div className={jcn('Corner-SW')}>Среднее</div>
    {tests.map((test, index)=><Footer key={index} users={users} test={test} results={results.filter((i)=>i.test === test.id)}/>)}
    <div className={jcn('Corner-SE')}></div>
    </>
}

